module.exports = __webpack_public_path__ + "static/media/AcabadosIcon.47196b13.svg";